// ============================================================================
// ENUM MASTER SERVICE
// ============================================================================

import { get } from '../client/axiosClient';
import { enumEndpoints } from '../endpoints/enum.endpoints';
import type { ApiResponse } from '../types';
import type { EnumItem } from '../types/enum.types';

class EnumService {
  async getByGroup(group: string): Promise<ApiResponse<EnumItem[]>> {
    const response = await get<ApiResponse<EnumItem[]>>(enumEndpoints.getByGroup(group));
    return response.data;
  }
}

export const enumService = new EnumService();
export default enumService;
